import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../config/payrollApiConfig';

// Create Salary Transaction
export const createSalaryTransaction = createAsyncThunk(
  'salaryTransaction/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.post('/salary-transactions', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create salary transaction');
    }
  }
);

// Fetch All Salary Transactions
export const fetchSalaryTransactions = createAsyncThunk(
  'salaryTransaction/fetchAll',
  async (
    args: { year?: number; month?: number } = {}, // ✅ default value avoids error
    { rejectWithValue }
  ) => {
    try {
      const response = await payrollServiceApiInstance.get('/salary-transactions', {
        params: args // will be {} if no year/month passed
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch salary transactions');
    }
  }
);

// Fetch Salary Transaction by ID
export const fetchSalaryTransactionById = createAsyncThunk(
  'salaryTransaction/fetchById',
  async (transactionId: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get(`/salary-transactions/${transactionId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch salary transaction');
    }
  }
);

// Update Salary Transaction
export const updateSalaryTransaction = createAsyncThunk(
  'salaryTransaction/update',
  async ({ id, ...data }: any & { id: number }, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.put(`/salary-transactions/${id}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update salary transaction');
    }
  }
);

// Delete Salary Transaction
export const deleteSalaryTransaction = createAsyncThunk(
  'salaryTransaction/delete',
  async (transactionId: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.delete(`/salary-transactions/${transactionId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete salary transaction');
    }
  }
);
// Fetch Salary Transactions by Employee ID
export const fetchSalaryTransactionsByEmployeeId = createAsyncThunk(
  'salaryTransaction/fetchByEmployeeId',
  async (employeeId: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get(`/salary-transactions/employee/${employeeId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch transactions for the employee');
    }
  }
);

